<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <search-form :class="['mb-4']" />
        <template v-if="results.length && indexes.length">
          <alert :dismissible="false" :class="['mb-4']" type="success" v-model="resultsFound">{{ $lang.searchResultsFor(q, results.length) }}</alert>
          <list :class="['mr-1', 'mb-4']">
            <list-item :title="$lang.goTo(result.title)" v-for="(result, index) in results" :key="index" tag="router-link" :to="result.url">
              <list-item-avatar>
                <avatar color="white" :text="index + 1" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" />
              </list-item-avatar>
              <list-item-content>
                <list-item-content-title v-html="result.title" />
                <list-item-content-sub-title :truncate="false" v-html="result.description" />
              </list-item-content>
              <list-item-icon>
                <icon name="chevron-double-right" />
              </list-item-icon>
            </list-item>
          </list>
        </template>
        <alert type="error" :dismissible="false" v-if="!results.length && indexes.length" v-model="alert" :class="['mb-4']">{{ $lang.noSearchResultsFor(q) }}</alert>
      </flex-col>
    </flex>
    <reactive-style>
    .page-meta p {
      display: none;
    }
    </reactive-style>
  </container>
</template>
<script>
export default {
  name: 'PageSearch',
  data () {
    return {
      q: null,
      resultsFound: true,
      alert: true,
      indexes: [],
      results: []
    }
  },
  mounted () {
    this.$route.query.q ? this.getIndexes() : this.pushToRoot()
  },
  watch: {
    '$route.query' () {
      this.getQuery()
    }
  },
  methods: {
    getQuery () {
      this.q = this.$route.query.q || null
      this.q ? this.search() : this.pushToRoot()
    },
    pushToRoot () {
      this.$router.push({
        path: '/'
      })
    },
    search () {
      this.results = this.indexes.filter(page => page.content.includes(this.q.toLowerCase()))
    },
    getIndexes () {
      this.$http({
        url: `${this.$root.config.staticAssetsDir}/data/miscellaneous/indexes.json`
      }).then(response => {
        if (response.status === 200 && response.data) {
          this.indexes = response.data
          this.getQuery()
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/search.vue